module.exports = __webpack_public_path__ + "img/cloud-database-tree.cea91a9a.svg";